import SelectMenu from './SelectMenu'

export { sortOptions } from './SelectMenu'

export default SelectMenu
